import type { Optional } from '@festina-life/core'
import { IconButton } from '@festina-life/ui/actions'
import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'

import { ErrorMessageBody } from './ErrorMessageBody'
import { errorToSeverity, toTitle } from './utils'

export type ErrorMessageProps = {
  title?: string
  error: Optional<Error>
  retryAction?: () => void
  onClose?: () => void
  className?: string
}

/**
 * Tries to show relevant information about an error that is thrown.
 * Does not handle ValidationErrorMessages since they are shown using ValidationErrorMessageAlert.tsx
 * This is to be able to handle overridable errors in life forms.
 */
export const ErrorMessage = ({
  title,
  error,
  retryAction,
  onClose,
  className,
}: ErrorMessageProps) => {
  const translate = useTranslate()

  return error ? (
    <Alert
      className={className}
      severity={errorToSeverity(error)}
      action={
        retryAction && (
          <IconButton
            onClick={retryAction}
            tip={translate('retry')}
            iconName="ArrowPath"
            className="text-inherit!"
            iconSize="md"
          />
        )
      }
      title={title ?? toTitle(error, translate)}
      onClose={onClose}
    >
      <ErrorMessageBody error={error} />
    </Alert>
  ) : null
}
